import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type BillVoidParams = {
  id: string;
};

export const billVoidAtom = createMutationAtomFactory(
  'finance.billVoid',
  (params: BillVoidParams) => ({
    financeBillVoid: {
      __args: {
        id: params.id,
      },
      id: true,
      documentNumber: true,
      status: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
